// /corpus/components/reusable/TreeSection.tsx
import {useEffect, useState} from 'react';
import {Box} from '@mui/material';
import {buildTree, filterByIds, ListItem} from '../utils';
import ArrTreeView from '../../common/arr-tree-view/ArrTreeView';
import {CorpusFilterState, useCorpusContext} from '../ViewCategorization';
import ArrLoadingSpinner from '../../common/arr-loading-spinner/ArrLoadingSpinner';
import {useSearchParams} from 'react-router-dom';
import {RootState} from '../../../redux/store';
import {useSelector} from 'react-redux';

interface TreeSectionProps {
  fetchHook: any; // custom hook that returns {data}
  securityGroupId?: number | string;
  type: string;
}

const TreeSection = ({fetchHook, securityGroupId, type}: TreeSectionProps) => {
  const [treeData, setTreeData] = useState<ListItem[]>([]);
  const [treeSelectedIds, setTreeSelectedIds] = useState<string[] | null>(null);
  const [defaultIdsWithTreeId, setDefaultIdsWithTreeId] = useState<string[]>(
    []
  );
  const {setCorpusFilter, corpusFilter} = useCorpusContext();
  const [proviewIdSearch] = useSearchParams();
  const {corpusDetails} = useSelector(
    (state: RootState) => state?.categorization
  );

  // API CALL
  const {data: apiData = [], isLoading = false} = securityGroupId
    ? fetchHook(Number(securityGroupId))
    : fetchHook();

  // FORMAT TREE
  useEffect(() => {
    if (
      ((apiData.length > 0 && proviewIdSearch.get('proviewId')) ||
        corpusDetails) &&
      corpusFilter
    ) {
      const selectedIds = corpusFilter[type as keyof CorpusFilterState].map(
        (item) => item.id.toString()
      );
      const {roots, selectedSet} = buildTree(apiData, selectedIds);
      setTreeData(roots);
      setDefaultIdsWithTreeId(Array.from(selectedSet));
      setTreeSelectedIds(selectedIds);
    } else if (apiData.length > 0 && !proviewIdSearch.get('proviewId')) {
      const {roots} = buildTree(apiData);
      setTreeData(roots);
    }
  }, [apiData, corpusFilter]);

  const handleSelection = (selectedItems: string[] | null) => {
    setCorpusFilter((prev: CorpusFilterState) => ({
      ...prev,
      [type]: filterByIds(apiData, selectedItems, type),
    }));
  };

  return (
    <Box className="tree-container">
      {isLoading ? (
        <ArrLoadingSpinner />
      ) : (
        treeData.length > 0 && (
          <ArrTreeView
            selectedItem=""
            isShowCheckbox={true}
            multipleSelection={true}
            isShowFileType={false}
            itemsList={treeData}
            setSelectedItem={handleSelection}
            treeSelectedItems={treeSelectedIds}
            defaultExpandedIds={defaultIdsWithTreeId}
          />
        )
      )}
    </Box>
  );
};

export default TreeSection;
